import AWS from "aws-sdk";

// Configure AWS
AWS.config.update({
  region: "eu-north-1",
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  },
});

const s3 = new AWS.S3();

// Single file upload (original function, kept as default export)
const uploadToS3 = async (file, folder) => {
  const params = {
    Bucket: "indiancommunity",
    Key: `${folder}${Date.now()}_${file.name}`,
    Body: file,
    ContentType: file.type,
  };
  try {
    const data = await s3.upload(params).promise();
    return data.Location; // Return the S3 URL
  } catch (error) {
    console.error("Error uploading file", error);
    throw error;
  }
};

// Bulk file upload (named export)
export const bulkUploadToS3 = async (files, folder, onProgress) => {
  const BATCH_SIZE = 20; // Increased batch size for faster uploads
  const urls = [];

  // Process files in batches
  for (let i = 0; i < files.length; i += BATCH_SIZE) {
    const batch = files.slice(i, i + BATCH_SIZE);
    const uploadPromises = batch.map(async (file) => {
      const params = {
        Bucket: "indiancommunity",
        Key: `${folder}${Date.now()}_${file.name}`,
        Body: file,
        ContentType: file.type,
      };

      try {
        const data = await s3.upload(params).promise();
        return data.Location; // Collect the S3 URL
      } catch (error) {
        console.error(`Error uploading ${file.name}`, error);
        throw error; // Re-throw to handle in the calling function
      }
    });

    // Wait for the current batch to complete
    const batchUrls = await Promise.all(uploadPromises);
    urls.push(...batchUrls);
    if (onProgress) {
      onProgress(Math.min(((i + BATCH_SIZE) / files.length) * 100, 100));
    }
  }

  return urls; // Return array of all uploaded file URLs
};

export default uploadToS3;
